import React from "react";
import styled, { keyframes } from "styled-components";

import Skeleton from "../../components/layout/skeleton";
import { colors, breakpoints } from "../../../theme";
import {
  SUB_FEATURED_PROJECTS,
  DISPLAYED_PROJECTS,
} from "../../utils/constants/projects";
import {
  CardsStack,
  SubCards,
  ProjectCardRoot,
  CardFigure,
  CardBody,
  TitleStack,
  BadgeRow,
  MoreProjectsWrap,
} from "./styles";

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
`;

const PulseBone = styled(Skeleton)`
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

const FigureBone = styled(CardFigure)`
  background-color: ${colors.grey.medium};
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

const BadgeBone = styled(PulseBone)`
  height: 24px;
  width: 72px;
  border-radius: 20px;
`;

const ButtonBone = styled(PulseBone)`
  height: 48px;
  width: 160px;
  border-radius: 18px;
  margin-top: auto;
  display: none;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: block;
  }
`;

const ArrowBone = styled(PulseBone)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-top: auto;
  margin-left: auto;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: none;
  }
`;

const MoreButtonBone = styled(PulseBone)`
  height: 48px;
  width: 180px;
  border-radius: 18px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 66px;
    width: 220px;
  }
`;

const ProjectCardSkeleton = ({ variant }) => (
  <ProjectCardRoot $variant={variant} $bgColor={colors.surface}>
    <FigureBone $variant={variant} as="div" />
    <CardBody $variant={variant}>
      <TitleStack $variant={variant}>
        <PulseBone height="16px" width="40%" />
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <PulseBone height="22px" width="100%" />
          <PulseBone height="22px" width="75%" />
        </div>
      </TitleStack>
      <BadgeRow>
        <BadgeBone />
        <BadgeBone />
        <BadgeBone />
      </BadgeRow>
      {variant === "main" ? <ButtonBone /> : <ArrowBone />}
    </CardBody>
  </ProjectCardRoot>
);

const ProjectCardsSkeleton = ({ mode = "landing" }) => {
  const isLanding = mode !== "all";

  if (!isLanding) {
    return (
      <CardsStack $stacked aria-hidden>
        {DISPLAYED_PROJECTS.map((project) => (
          <ProjectCardSkeleton key={project.slug} variant="main" />
        ))}
      </CardsStack>
    );
  }

  return (
    <CardsStack aria-hidden>
      <ProjectCardSkeleton variant="main" />
      <SubCards>
        {SUB_FEATURED_PROJECTS.map((project) => (
          <ProjectCardSkeleton key={project.slug} variant="default" />
        ))}
      </SubCards>
      <MoreProjectsWrap>
        <MoreButtonBone />
      </MoreProjectsWrap>
    </CardsStack>
  );
};

export default ProjectCardsSkeleton;
